import type { ReactNode } from 'react'
import './TestimonialGrid.css'

export interface TestimonialGridProps {
  children: ReactNode
}

export function TestimonialGrid({ children }: TestimonialGridProps) {
  return <div className="azoya-testimonial-grid">{children}</div>
}
